import {FieldFilterPickerGroup, FieldFilterPicker, Override} from "@bryntum/schedulerpro";

FieldFilterPickerGroup.configurable.items.addFilterButton = {
  ...FieldFilterPickerGroup.configurable.items.addFilterButton,
  cls: "w-full",
  rendition: 'outlined'
};
// Adding an apply filter button to apply all the filters in grid
FieldFilterPickerGroup.configurable.items.applyFilterBtn = {
  type: "button",
  text: "Apply Filter",
  onClick: ({ source }) => {
    source.owner.filters.forEach((_filter, filterIndex) => {
      source.owner.getFilterPicker(filterIndex).triggerChange(true);
    })
  },
  rendition: 'filled'
}

Override.apply(
  class {
    static target = {
      class: FieldFilterPickerGroup
    }

    //Applying scroll on filter picker group
    afterConstruct() {
      this.cls = "overflow-y-auto px-3 [&_.b-field-filter-picker-group-row]:!px-0";
      this.maxHeight = "36em";
      this.keyMap = {
        enter: {
          handler: () => {
            const { applyFilterBtn } = this.widgetMap;
            // When a filter field is focused and the user presses enter, the latest value of the filter field is not applied to the filter.
            // To ensure the value is saved, focus is assigned to the apply button before triggering its click event.
            applyFilterBtn.focus();
            applyFilterBtn.trigger("click");
            // Hide Popup
            this.owner.hide();
          }
        }
      }
      this._overridden.afterConstruct.call(this);
    }

    updateFilters(newFilters, oldFilters) {
      const me = this;
      if (oldFilters) {
        oldFilters
          .filter(filter => !newFilters.find(newFilter => newFilter.id === filter.id))
          .forEach(filter => me.store?.removeFilter(filter.id));
      }
      newFilters.forEach(filter => filter.id = filter.id || me.nextFilterId);
      me.widgetMap.pickers.items = newFilters?.map(filter => {
        // When filter popup opens, default `contains` options is selected for filter
        if (!filter.operator) {
          const filterType = this.grid.features.filter.pickerConfig.fields[filter.property].type;
          if (filterType === "number") {
            filter.operator = ">=";
          } else if (filterType === "_swivu_settings") {
            filter.operator = "isIncludedIn";
          } else {
            filter.operator = "includes";
            filter.caseSensitive = false;
          }
        }
        return me.getPickerRowConfig(filter)
      }) || [];
    }

    addFilter({ property = null, operator = "includes", value = null } = {}) {
      this._overridden.addFilter.call(this, { property, operator, value })
    }
  }
)

Override.apply(
  class {
    static target = {
      class: FieldFilterPicker
    }

    afterConstruct() {
      this._overridden.afterConstruct.call(this);
      // Applying focus on the value field whenever a FieldFilterPicker's instance is created
      // Combo is focused after initialization therefore applying timeout to focus text field
      setTimeout(() => {
        this.eachWidget((widget) => {
          if (widget.isTextField) {
            widget.focus();
          }
        })
      })
    }

    // This function is being triggered whenever any value in the picker fields or checkbox is changed
    // Applying `canApply` check because we now only want to apply filter when apply Filter button is clicked
    // Also it needs to be checked whenever bryntum's version is updated because `triggerChange` is an internal function
    // https://github.com/Swivu/swivu-mono/pull/533#discussion_r1381628633
    triggerChange(canApply = false) {
      if (canApply) {
        const {filter, isValid} = this;
        this.trigger('change', {
          filter,
          isValid
        });
      }
    }
  }
)
